

















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

export interface UiTooltipIconPreset {
  name: string
  icon: string;
  color: string;
}

@Component
export default class UiTooltipIcon extends Vue {
  @Prop()
  icon: string;

  @Prop()
  color: string;

  @Prop()
  text: string;

  @Prop({ default: 12 })
  size: number;
  
  @Prop()
  preset: string; 

  get presets(): UiTooltipIconPreset[] {
    return [
      {
        name: 'help',
        icon: 'fas fa-question-circle',
        color: this.$colors.green, //'ui-tooltip-icon__icon--color-accent'
      },
      {
        name: 'warning',
        icon: 'fas fa-exclamation-triangle',
        color: this.$colors.sunglow, //'ui-tooltip-icon__icon--color-warning'
      },
      {
        name: 'error',
        icon: 'fas fa-exclamation-circle',
        color: this.$colors.red, //'ui-tooltip-icon__icon--color-error'
      }
    ]
  }

  get pPreset() {
    return this.presets.find((item) => item.name === this.preset);
  }

  get pIcon() {
    return this.icon || this.pPreset.icon;
  }

  get pColor() {
    return this.color || this.pPreset.color;
  }
}
